import Cookie from "js-cookie";
import SSRCookie from "cookie";
import {
  AUTH_CRED,
  PIN_AUTH_CRED,
  CUSTOMER,
  OBSERVER,
  ROLES,
  STAFF,
  STORE_OWNER,
  SUPER_ADMIN,
  TOKEN,
} from "./constants";

export const allowedRoles = [SUPER_ADMIN, STORE_OWNER, STAFF, OBSERVER];
export const adminAndOwnerOnly = [SUPER_ADMIN, STORE_OWNER];
export const adminOwnerAndStaffOnly = [SUPER_ADMIN, STORE_OWNER, STAFF];
export const allAdminUsers = [SUPER_ADMIN, STORE_OWNER, STAFF, OBSERVER];
export const fixedRoles = [SUPER_ADMIN, STORE_OWNER, CUSTOMER];
export const adminOnly = [SUPER_ADMIN];
export const ownerOnly = [STORE_OWNER];

export function setAuthCredentials(token: string, roles: any, permissions: any[] = []) {
  Cookie.set(AUTH_CRED, { token, roles, permissions });
}

export function setTwoFactorAuthCredentials(two_fa_token: string) {
  Cookie.set(PIN_AUTH_CRED, two_fa_token, { expires: 30 });
}

export function getAuthCredentials(context?: any): {
  token: string | null;
  roles: string[] | null;
  permissions: string[] | null;
} {
  let authCred;
  if (context) {
    authCred = parseSSRCookie(context)[AUTH_CRED];
  } else {
    authCred = Cookie.get(AUTH_CRED);
  }
  if (authCred) {
    return JSON.parse(authCred);
  }
  return { token: null, roles: null, permissions: null };
}

export function getTwoFactorAuthCredentials(context?: any): string | null {
  let twoFactorAuthCred;
  if (context) {
    twoFactorAuthCred = parseSSRCookie(context)[PIN_AUTH_CRED];
  } else {
    twoFactorAuthCred = Cookie.get(PIN_AUTH_CRED);
  }
  return twoFactorAuthCred ?? null;
}

export function parseSSRCookie(context: any) {
  return SSRCookie.parse(context.req.headers.cookie ?? "");
}

export function hasAccess(
  _allowedRoles: string[],
  _userRoles: string[] | undefined | null
) {
  if (_userRoles) {
    return Boolean(
      _allowedRoles?.find((aRole) => _userRoles.includes(aRole))
    );
  }
  return false;
}

export function hasPermissions(
  _allowedPermissions: string[],
  _userPermissions: string[] | undefined | null,
  _userRoles: string[] | undefined | null,
  _match: "some" | "all" = "some"
) {
  if (_userPermissions) {
    return Boolean(
      _allowedPermissions?.find((aPermission) => _userPermissions.includes(aPermission)) ||
      (_userRoles && _userRoles.includes(SUPER_ADMIN))
    );
  }
  return false;
}
export function isUserAllowedTo(_allowedPermissions: string[], _match: "some" | "all" = "some") {
  const { roles, permissions } = getAuthCredentials();
  return hasPermissions(_allowedPermissions, permissions, roles, _match);
}
export function isAuthenticated(_cookies: any) {
  return (
    !!_cookies[TOKEN] &&
    Array.isArray(_cookies[ROLES]) &&
    !!_cookies[ROLES].length
  );
}
